import * as React from 'react';
import Select from 'react-select';
import * as AiIcons from 'react-icons/ai';
import * as BiIcons from "react-icons/bi";
import * as BsIcons from "react-icons/bs";
import * as FaIcons from "react-icons/fa";
import * as GiIcons from "react-icons/gi";
import * as MdIcons from "react-icons/md";

export default class SelectItem extends React.Component {

    iconType(type) {
        switch (type) {
            case 'sexo': return (
                <span className="input-group-text" id="sangreicon"><BsIcons.BsGenderAmbiguous /></span>
            );
            case 'estadocivil': return (
                <span className="input-group-text" id="sangreicon"><GiIcons.GiDiamondRing /></span>
            );
            case 'sangre': return (
                <span className="input-group-text span-background" id="sangreicon"><MdIcons.MdOutlineBloodtype style={{ color: "white" }} /></span>
            );
            case 'genero': return (
                <span className="input-group-text span-background" id="generoicon"><BsIcons.BsPersonFill style={{ color: "white" }} /></span>
            );
            case 'etnia': return (
                <span className="input-group-text span-background" id="generoicon"><BsIcons.BsFillPeopleFill style={{ color: "white" }} /></span>
            );
            case 'pais': return (
                <span className="input-group-text span-background" id="paisicon"><FaIcons.FaFlag style={{ color: "white" }} /></span>
            );
            case 'provincia': return (
                <span className="input-group-text span-background" id="provinciaicon"><FaIcons.FaMapMarkerAlt style={{ color: "white" }} /></span>
            );
            case 'codarea': return (
                <span className="input-group-text span-background" id="codareicon"><AiIcons.AiOutlineAim style={{ color: "white" }} /></span>
            );
            case 'nombre': return (
                <span className="input-group-text span-background" id="nombreicon"><BsIcons.BsPersonFill style={{ color: "white" }} /></span>
            );
            case 'parenteso': return (
                <span className="input-group-text span-background" id="parenticon"><GiIcons.GiFamilyTree style={{ color: "white" }} /></span>
            );
            case 'telefono': return (
                <span className="input-group-text span-background" id="tipofonoicon"><FaIcons.FaPhone style={{ color: "white" }} /></span>
            );
        }
    }

    state = {
        selectedValue: this.props.value,
    };

    handleChange = (selectedValue, event) => {
        this.setState(
            { selectedValue },
            (() => { this.props.onChange(selectedValue, event) })
        );
    };

    render() {

        const customStyles = {
            container: (provided, state) => ({
                ...provided,
                height: "27px",
                position: "relative",
                flex: "1 1 auto",
                width: "1%",
                minWidth: "0",
                marginBottom: "0",
            }),
            indicatorsContainer: (provided, state) => ({
                ...provided,
                width: "0%",
                display: "none"
            }),
            indicatorSeparator: (provided, state) => ({
                ...provided,
                width: "0%",
                display: "none"
            }),
            control: (provided, state) => {
                const backgroundColor = state.isDisabled ? "#e9ecef" : "#fff";
                return {
                    ...provided,
                    minHeight: '30px',
                    height: '30px',
                    fontSize: 'small',
                    alignContent: 'center',
                    borderRadius: '0.1rem',
                    backgroundColor,
                    border: '1px solid #ced4da'
                }
            },
            option: (provided, state) => {
                const color = state.isDisabled ? "#495057" : "#333333";
                return { ...provided, fontSize: 'small', color }
            }
        };

        return (
            <div className="input-group">
                <Select
                    options={this.props.options}
                    value={(this.props.value ? this.props.options.find(obj => obj.value === this.props.value) : null)}
                    name={this.props.name}
                    id={this.props.idname}
                    placeholder={this.props.placeholder}
                    onChange={this.handleChange}
                    styles={customStyles}
                    isDisabled={(this.props.disabled)}
                />
                {this.iconType(this.props.tipoicono)}
            </div>
        );
    }
}